module.exports = __webpack_public_path__ + "media/images/meta/clubpilates/favicon-5d67796a8dd5214a7c5ff4edf0abdf2f.png";